const displayVehicleInfo = (model) => {
    const { vehicle_year, vehicle_make, vehicle_model, vehicle_seatbelts } = model;
    return `${vehicle_year} ${vehicle_make} ${vehicle_model}, ${vehicle_seatbelts} back seatbelts`;
};
export default displayVehicleInfo;
